module.exports = __webpack_public_path__ + "static/media/mobipix_white_logo.6f1f00b3.png";